module.exports = __webpack_public_path__ + "static/media/coin-5.e934cf80.gif";